"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import { useGridItemProps } from './hooks/useGridItemProps.mjs';
import { useList } from '../../../../hooks/useList.mjs';
import ItemsGridListItemView from '../../../../../../views/ItemsGridListItemView.mjs';
import { Suspense } from 'react';
import styles from './Item.module.scss.mjs';
import { ListItemSkeletonView } from './components/ListItemSkeletonView/ListItemSkeletonView.mjs';

const Item = (props) => {
  const { id, data } = props;
  const list = useList();
  const itemView = list.itemView;
  const { gridItemProps, children } = useGridItemProps(props);
  if (!itemView) {
    return null;
  }
  const textValue = itemView.textValue ? itemView.textValue(data) : void 0;
  const href = itemView.href ? itemView.href(data) : void 0;
  const hasAction = !!gridItemProps.onAction || !!href;
  return /* @__PURE__ */ jsx(
    ItemsGridListItemView,
    {
      id,
      textValue,
      href,
      hasAction,
      isTile: list.viewMode === "tiles",
      ...gridItemProps,
      children: /* @__PURE__ */ jsx(Suspense, { fallback: /* @__PURE__ */ jsx(ListItemSkeletonView, { viewMode: list.viewMode }), children })
    }
  );
};
const ItemContainer = (props) => {
  const list = useList();
  return /* @__PURE__ */ jsx(
    ItemsGridListItemView,
    {
      textValue: "-",
      className: styles.item,
      isTile: list.viewMode === "tiles",
      children: props.children
    }
  );
};

export { Item, ItemContainer, Item as default };
//# sourceMappingURL=Item.mjs.map
